module.exports = __webpack_public_path__ + "static/img/6.c0e4a04.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/eng/6.png
// module id = fHEU
// module chunks = 0